import { render, staticRenderFns } from "./warningSet.vue?vue&type=template&id=2e043f8e&scoped=true&"
import script from "./warningSet.vue?vue&type=script&lang=js&"
export * from "./warningSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e043f8e",
  null
  
)

export default component.exports